import UploadNda from '../components/ProjectWizard/UploadNda';

const UploadNdaPage = () => {
    return <UploadNda></UploadNda>;
};
export default UploadNdaPage;
